import {
  START_LOADING,
  STOP_LOADING,
  SUCCESS,
  GET_CHIT_POSTING_LISTS,
  GET_BATCH_POSTING_LISTS,
} from "../types/index";
import * as api from "../api/index.js";

const appendPostingTypes = (query, postingTypes) => {
  if (!postingTypes?.length) return query;
  let q = query;
  postingTypes.forEach((item) => {
    q += `&PostingTypes=${encodeURIComponent(item)}`;
  });
  return q;
};

export const getChitPostingList =
  (page, limit, parameter, type, sort) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      let query = "";

      if (parameter?.chitStatus) {
        query += `Status=${encodeURIComponent(parameter.chitStatus)}`;
      } else {
        if (parameter?.postingStatus === "true") {
          query += `Posted=true`;
        } else if (parameter?.postingStatus === "false") {
          query += `Posted=false`;
        }
        if (
          parameter?.authorizationRequired === true &&
          !parameter?.chitStatus
        ) {
          query += `${query ? "&" : ""}AuthorizationRequired=true`;
        }
      }

      if (parameter?.fromDate != null && parameter?.fromDate !== "") {
        query += `${query ? "&" : ""}fromDate=${encodeURIComponent(parameter.fromDate)}`;
      }
      if (parameter?.toDate != null && parameter?.toDate !== "") {
        query += `${query ? "&" : ""}toDate=${encodeURIComponent(parameter.toDate)}`;
      }

      if (parameter?.matterId !== undefined && parameter?.matterId !== null) {
        query += `${query ? "&" : ""}MatterId=${parameter.matterId}`;
      }

      query = appendPostingTypes(query, parameter?.postingTypes);

      if (parameter?.urgent === true) {
        query += `${query ? "&" : ""}urgent=true`;
      }

      let orderby;
      if (sort === undefined || sort === null) {
        orderby = "matterRef";
      } else if (sort.dir === "asc") {
        orderby = sort.field;
      } else if (sort.dir === "desc") {
        orderby = `${sort.field} desc`;
      }

      const datas = await api.getChitPostingList(page, limit, query, orderby);
      if (type === "batchPosting") {
        dispatch({ type: GET_BATCH_POSTING_LISTS, payload: datas.data });
      } else {
        dispatch({ type: GET_CHIT_POSTING_LISTS, payload: datas.data });
      }
      dispatch({ type: STOP_LOADING });
      dispatch({ type: SUCCESS, payload: datas.message });
      return datas.data;
    } catch (error) {
      dispatch({ type: STOP_LOADING });
      return undefined;
    }
  };
